module.exports = __webpack_public_path__ + "images/127_4096.jpg";